import React from "react";
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Col, Spinner } from "reactstrap";
import classNames from "classnames";
import FormGenerator from "components/customs/form-generator/input";
import { useNavigate } from "react-router";
import {
  FormActionsSection,
  FormRow,
  RequiredIndicator,
  StyledCancelButton,
  StyledSaveButton,
} from "assets/js/Styles";
import styled from "styled-components";
import { POSITION_OTHERS } from "views/directory/constants";

const LastNameFiledContainer = styled(FormRow)`
  margin-top: 0;
`;

const validSchema = Yup.object().shape({
  lastName: Yup.string().required("Required"),
  firstName: Yup.string().required("Required"),
  contact: Yup.string()
    .min(11, "At least 11 digits")
    .max(11, "Cannot be more than 11 digits")
    .matches(/^(09)\d{9}$/, "Invalid format")
    .required("Required"),
});

const OthersForm = ({
  handleOnSubmit,
  formFields,
  setFormFields,
  isLoading,
  isModal,
  setIsModalShown,
}) => {
  const navigate = useNavigate();

  return (
    <Formik
      validationSchema={validSchema}
      onSubmit={handleOnSubmit}
      initialValues={formFields}
      enableReinitialize
    >
      {({ handleChange, values }) => (
        <Form>
          <Field name="lastName">
            {({ form: { touched, errors } }) => (
              <LastNameFiledContainer>
                <Col
                  xs="12"
                  sm="6"
                  md="12"
                  lg="6"
                >
                  <h5>
                    {"Last Name"}
                    {RequiredIndicator}
                  </h5>
                </Col>
                <Col
                  xs="12"
                  sm="6"
                  md="12"
                  lg="6"
                >
                  <FormGenerator
                    type="text"
                    name="lastName"
                    className={classNames({
                      "is-invalid": errors?.lastName && touched?.lastName,
                    })}
                    value={values.lastName}
                    onChange={(evt) => {
                      handleChange(evt);

                      setFormFields({
                        ...formFields,
                        lastName: evt.target.value,
                      });
                    }}
                  />

                  <ErrorMessage name="lastName">
                    {(msg) => (
                      <small className="field-error text-danger">{msg}</small>
                    )}
                  </ErrorMessage>
                </Col>
              </LastNameFiledContainer>
            )}
          </Field>

          <Field name="firstName">
            {({ form: { touched, errors } }) => (
              <FormRow>
                <Col
                  xs="12"
                  sm="6"
                  md="12"
                  lg="6"
                >
                  <h5>
                    {"First Name"}
                    {RequiredIndicator}
                  </h5>
                </Col>
                <Col
                  xs="12"
                  sm="6"
                  md="12"
                  lg="6"
                >
                  <FormGenerator
                    type="text"
                    name="firstName"
                    className={classNames({
                      "is-invalid": errors?.firstName && touched?.firstName,
                    })}
                    value={values.firstName}
                    onChange={(evt) => {
                      handleChange(evt);

                      setFormFields({
                        ...formFields,
                        firstName: evt.target.value,
                      });
                    }}
                  />
                  <ErrorMessage name="firstName">
                    {(msg) => (
                      <small className="field-error text-danger">{msg}</small>
                    )}
                  </ErrorMessage>
                </Col>
              </FormRow>
            )}
          </Field>

          <Field name="contact">
            {({ form: { touched, errors } }) => (
              <FormRow>
                <Col
                  xs="12"
                  sm="6"
                  md="12"
                  lg="6"
                >
                  <h5>
                    {"Contact Number"}
                    {RequiredIndicator}
                  </h5>
                </Col>
                <Col
                  xs="12"
                  sm="6"
                  md="12"
                  lg="6"
                >
                  <FormGenerator
                    name="contact"
                    type="mobile"
                    className={classNames({
                      "is-invalid": errors?.contact && touched?.contact,
                    })}
                    value={values.contact || ""}
                    onChange={(value) => {
                      handleChange({
                        target: { name: "contact", value },
                      });

                      setFormFields({
                        ...formFields,
                        contact: value,
                      });
                    }}
                  />
                  <ErrorMessage name="contact">
                    {(msg) => (
                      <small className="field-error text-danger">{msg}</small>
                    )}
                  </ErrorMessage>
                </Col>
              </FormRow>
            )}
          </Field>

          <FormActionsSection>
            <StyledCancelButton
              outline
              disabled={isLoading}
              onClick={(e) => {
                if (isModal) {
                  setIsModalShown(false);
                  e.preventDefault();
                } else {
                  navigate("/directory", {
                    state: { view: POSITION_OTHERS },
                  });
                }
              }}
            >
              {"Cancel"}
            </StyledCancelButton>

            <StyledSaveButton
              color="primary"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? (
                <Spinner
                  animation="border"
                  color="light"
                  size="sm"
                />
              ) : (
                "Save"
              )}
            </StyledSaveButton>
          </FormActionsSection>
        </Form>
      )}
    </Formik>
  );
};

export default OthersForm;
